import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import MapPicker from "./MapPicker";
import { connect } from "react-redux";
import { getPosition, getSelectedCountry, getArea } from "./helpers";
import { Redirect } from "react-router-dom";
import {
  getOrderPassDomain,
  getStorefrontOrderPassAddressData,
  hydrateOrderPassAddresses,
  isOrderPassPhoneVerified,
  normalizeOrderPassPhone,
  shouldRequireOrderPassVerification,
} from "../../../Helpers/orderPass";
import { setOrderPassData } from "../../../store/actions";
import instance from "../../../store/actions/instance";

class MapPickerPage extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  isOrderPassAreaSelectionFlow = () =>
    !!this.props.settings.enable_orderpass &&
    this.props.history.location.state?.orderPassEntry === "area_select";

  hasCartItems = () =>
    this.props.cart.delivered_items > 0 || this.props.cart.charged_items > 0;

  getOrderPassHydrationContext = () => ({
    settings: this.props.settings,
    areas: this.props.areas,
    branchDeliveryCharges: this.props.branch_delivery_charges,
    countries: this.props.countries,
  });

  syncOrderPassMapPosition = async (nextAddress) => {
    if (
      !this.props.settings?.enable_orderpass ||
      !nextAddress?.orderPassAddressId ||
      !isOrderPassPhoneVerified(
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
      ) ||
      !this.props.orderPassStorefrontToken
    ) {
      return;
    }

    const phone = normalizeOrderPassPhone(this.props.customerContact?.phone);
    if (!phone) return;

    const addressPayload = getStorefrontOrderPassAddressData({
      address: nextAddress,
      settings: this.props.settings,
      areas: this.props.areas,
      branchDeliveryCharges: this.props.branch_delivery_charges,
      countries: this.props.countries,
    });
    if (!addressPayload) return;

    try {
      const response = await instance.post(
        `/order_pass/storefront_addresses/${nextAddress.orderPassAddressId}/`,
        {
          number: phone,
          domain: getOrderPassDomain(this.props.settings, this.props.store),
          storefront_token: this.props.orderPassStorefrontToken,
          ...addressPayload,
        },
      );

      if (!response.data?.success) return;

      this.props.setOrderPassData({
        phone,
        addresses: hydrateOrderPassAddresses(
          response.data?.account?.addresses || [],
          this.getOrderPassHydrationContext(),
        ),
        verifiedPhone: phone,
        linked: true,
        storefrontToken:
          response.data?.storefront_token || this.props.orderPassStorefrontToken,
      });
    } catch (error) {
      return;
    }
  };

  render() {
    const {
      language,
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings,
      branches,
      countries,
      cart,
    } = this.props;

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      const bdcObj = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      const areaObj = areas.find((a) => a.id === address?.area);
      selectedArea = areaObj || bdcObj;
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    console.log(selectedArea);

    // Same checks from index.js

    if (!settings.enable_delivery && !settings.enable_pickup)
      return <Redirect to="/" />;
    if (!this.hasCartItems() && !this.isOrderPassAreaSelectionFlow())
      return <Redirect to="/checkout/confirmation" />;
    if (
      shouldRequireOrderPassVerification(
        settings,
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
        this.props.orderPassGuestBypassPhone,
      )
    )
      return <Redirect to="/checkout/details" />;
    if (this.props.history.action == "POP" && !this.props.customerContact)
      return <Redirect to="/checkout/details" />;

    if (!address) return <Redirect to="/" />;

    if (
      (address.selectedDeliveryType === 1 || branch.isPickup) &&
      address.pickupArea
    )
      return <Redirect to="/select/branch" />;

    // The reason why this is here and not in MapPicker.js is because this only renders once
    const selectedCountryID = getSelectedCountry(
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings,
      branches
    );
    let countryObj = null;
    if (selectedCountryID) {
      countryObj = countries.find((c) => c.id === selectedCountryID);
    }

    return (
      <div
        className="border-top w-100"
        style={{
          marginTop: 55,
          backgroundColor: "#F5F5F5",
          height: "calc(100vh - 117px)",
          paddingRight: 1,
          overflow: "hidden",
          userSelect: "none",
        }}
      >
        <ProductHeader
          onBack={() => {
            if (this.props.history.location?.state?.checkout) {
              this.props.history.goBack();
            } else this.props.history.replace("/checkout/address", { type: 0 });
          }}
        />
        <MapPicker
          savePosition={(position) => {
            const nextAddress = {
              ...this.props.address,
              ...position,
              gpsConfirmed: true,
            };
            this.props.modifyAddress({
              ...position,
              gpsConfirmed: true,
            });
            this.syncOrderPassMapPosition(nextAddress);
            this.props.history.replace(
              this.isOrderPassAreaSelectionFlow() && !this.hasCartItems()
                ? "/"
                : this.props.history.location?.state?.checkout
                ? "/checkout/confirmation"
                : "/checkout/address",
            );
          }}
          countryObj={countryObj}
          defaultPosition={
            getPosition(
              address,
              branch,
              branch_delivery_charges,
              areas,
              settings
            ) || {
              lat: settings.base_lat_lng?.split(",")[0],
              lng: settings.base_lat_lng?.split(",")[1],
            }
          }
          selectedAreaObj={selectedArea}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    settings: state.store.store.settings,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    areas: state.store.store.areas,
    branches: state.store.store.branches,
    countries: state.store.store.all_countries || state.store.store.countries,
    cart: state.cart,
    customerContact: state.customers.customerContact,
    orderPassVerifiedPhone: state.customers.orderPassVerifiedPhone,
    orderPassStorefrontToken: state.customers.orderPassStorefrontToken,
    orderPassGuestBypassPhone: state.customers.orderPassGuestBypassPhone,
    auth: state.auth,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (position) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: position }),
    setOrderPassData: (data) => dispatch(setOrderPassData(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MapPickerPage);
